import { useLayoutEffect, useState } from 'react';

const GAP = 16;

/**
 * Opens the popover above its button, or below it when the fixed topbar would cover it,
 * e.g. in groups with few keywords, where the bar sits high on the screen
 * @param {Object} popoverRef Ref of the popover element, rendered inside the button wrapper
 * @returns {String} 'top' or 'bottom'
 */
const usePopoverPlacement = (popoverRef) => {
  const [placement, setPlacement] = useState('top');

  useLayoutEffect(() => {
    const popover = popoverRef.current;
    const anchor = popover?.parentElement;

    if (!popover || !anchor) return undefined;

    const updatePlacement = () => {
      const topbarBottom =
        document.querySelector('#page-topbar')?.getBoundingClientRect().bottom ?? 0;
      const anchorRect = anchor.getBoundingClientRect();
      const spaceAbove = anchorRect.top - topbarBottom - GAP;
      const spaceBelow = window.innerHeight - anchorRect.bottom - GAP;
      const height = popover.offsetHeight;

      setPlacement(height <= spaceAbove || spaceAbove >= spaceBelow ? 'top' : 'bottom');
    };

    updatePlacement();

    const resizeObserver = new ResizeObserver(updatePlacement);
    resizeObserver.observe(popover);
    window.addEventListener('scroll', updatePlacement, true);
    window.addEventListener('resize', updatePlacement);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', updatePlacement, true);
      window.removeEventListener('resize', updatePlacement);
    };
  }, [popoverRef]);

  return placement;
};

export default usePopoverPlacement;
